<i class="icon" [class]="size ? 'icon--' + size : ''">{{ icon }}</i>
